import React, { useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";
import { ResetPasswordEdit } from "../../api/api";
import "../CounsellorallEditPages/Resetpassword.css";
import { FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import bgImage from "../../../assets/images/brown-background.jpg";
import Swal from "sweetalert2";

// Validation schema
const validationSchema = Yup.object().shape({
  code: Yup.string()
    .min(6, "Code must be at least 6 characters")
    .required("Code is required"),
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("New Password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm New Password is required"),
});

const Resetpassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { email } = location.state?.values || {};

  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleSubmit = async (values) => {
    console.log("values2222", values);
    try {
      setIsLoading(true);
      const response = await ResetPasswordEdit(values);
      console.log("reset_api_response", response);
      if (response?.success) {
        // alert(response.msg);
        await Swal.fire({
          title: "Success!",
          text: response.msg,
          icon: "success",
          confirmButtonText: "OK",
        });
        navigate("/CounsellorSidebar/CounsellorEditProfile");
      } else {
        Swal.fire({
          title: "Error",
          text: response?.msg || "Something went wrong",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (err) {
      console.error("Reset password error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="mainResetContainer"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="Resetcontainer">
        <div className="ResetheadingText">
          <h3>Please Enter New Password</h3>
        </div>
        <Formik
          initialValues={{
            code: "",
            password: "",
            confirmPassword: "",
            email: email || "",
            type: "counsellor",
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({
            handleChange,
            handleBlur,
            handleSubmit,
            values,
            errors,
            touched,
          }) => (
            <form className="ResetformView" onSubmit={handleSubmit}>
              {/* Code */}
              <div className="ResetinputGroup">
                <FaLock />
                <input
                  type="text"
                  placeholder="Code"
                  maxLength={6}
                  name="code"
                  value={values.code}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </div>
              {touched.code && errors.code && (
                <div className="ReseterrorText">{errors.code}</div>
              )}

              {/* New Password */}
              <div className="ResetinputGroup">
                <FaLock />
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="New Password"
                  name="password"
                  value={values.password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                <span onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <FaEye /> : <FaEyeSlash />}
                </span>
              </div>
              {touched.password && errors.password && (
                <div className="ReseterrorText">{errors.password}</div>
              )}

              {/* Confirm Password */}
              <div className="ResetinputGroup">
                <FaLock />
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder="Confirm Password"
                  name="confirmPassword"
                  value={values.confirmPassword}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                <span
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? <FaEye /> : <FaEyeSlash />}
                </span>
              </div>
              {touched.confirmPassword && errors.confirmPassword && (
                <div className="ReseterrorText">{errors.confirmPassword}</div>
              )}

              {/* Submit */}
              <button
                type="submit"
                className="ResetsubmitButton"
                disabled={isLoading}
              >
                {isLoading ? "Saving..." : "Save"}
              </button>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default Resetpassword;
